import "./footer.css";
import { FaFacebookSquare, FaInstagram, FaTiktok, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// ✅ استبدال FaXTwitter بـ FaTelegram
import { FaTelegram } from "react-icons/fa6";
import { BiLogoWhatsapp } from "react-icons/bi";
import { useTranslation } from '../../../hooks/useTranslation';

export default function Footer() {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-section">
            <div className="footer-content-wrapper">
                <div className="footer-company-info">
                    <div className="footer-logo">
                        <h2 className="logo-text">hafid-<span className="logo-highlight">elmalek</span></h2>
                        <p className="company-tagline">{t('footerTagline')}</p>
                    </div>
                    <div className="footer-description">
                        <p className="description-text">
                            {t('footerDescription')}
                        </p>
                    </div>
                    <div className="footer-contact-details">
                        <div className="contact-item">
                            <FaMapMarkerAlt className="contact-icon" />
                            <span>{t('egyptAddress')}</span>
                        </div>
                        <div className="contact-item">
                            <FaPhoneAlt className="contact-icon" />
                            <span>01554132032</span>
                        </div>
                        <div className="contact-item">
                            <FaEnvelope className="contact-icon" />
                            <span>{t('email')}</span>
                        </div>
                    </div>
                </div>
                <div className="footer-social-section">
                    <h3 className="social-title">{t('contactUs')}</h3>
                    <p className="social-subtitle">{t('followUs')}</p>

                    <div className="social-links-grid">
                        {/* ✅ رابط فيسبوك محدث */}
                        <a href="https://www.facebook.com/share/1BrQmHyVRz/" target="_blank" rel="noopener noreferrer"
                            className="social-link facebook">
                            <div className="social-icon-wrapper">
                                <FaFacebookSquare className="social-icon" />
                            </div>
                            <span className="social-text">{t('facebook')}</span>
                        </a>

                        {/* ✅ رابط إنستغرام محدث */}
                        <a href="https://www.instagram.com/kingofshoes__?igsh=ZDI5bDFrMWMxNnkx" target="_blank" rel="noopener noreferrer"
                            className="social-link instagram">
                            <div className="social-icon-wrapper">
                                <FaInstagram className="social-icon" />
                            </div>
                            <span className="social-text">{t('instagram')}</span>
                        </a>

                        {/* ✅ رابط تيك توك محدث */}
                        <a href="https://www.tiktok.com/@hafidelmalk?_r=1&_t=ZS-98aeg9TaxGu" target="_blank" rel="noopener noreferrer"
                            className="social-link tiktok">
                            <div className="social-icon-wrapper">
                                <FaTiktok className="social-icon" />
                            </div>
                            <span className="social-text">{t('tiktok')}</span>
                        </a>

                        {/* ✅ استبدال تويتر بتليجرام */}
                        <a href="https://t.me/+k_1FixuFjStkZGU0" target="_blank" rel="noopener noreferrer"
                            className="social-link telegram">  {/* تم تغيير الكلاس إلى telegram */}
                            <div className="social-icon-wrapper">
                                <FaTelegram className="social-icon" />  {/* أيقونة تليجرام */}
                            </div>
                            <span className="social-text">telegram</span>  {/* تم تغيير النص */}
                        </a>

                        {/* ✅ رقم واتساب محدث */}
                        <a href="https://wa.me/201554132032" target="_blank" rel="noopener noreferrer"
                            className="social-link whatsapp">
                            <div className="social-icon-wrapper">
                                <BiLogoWhatsapp className="social-icon" />
                            </div>
                            <span className="social-text">{t('whatsappSocial')}</span>
                        </a>

                        {/* ✅ رقم الهاتف محدث */}
                        <a href="tel:+201554132032" className="social-link phone">
                            <div className="social-icon-wrapper">
                                <FaPhoneAlt className="social-icon" />
                            </div>
                            <span className="social-text">{t('callUs')}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="copyright">
                    <p> {t('allRightsReserved')} © {currentYear} hafidelmalk Egypt</p>
                </div>
                <div className="payment-methods">
                    <span className="payment-text">{t('paymentMethods')}</span>
                    <div className="payment-icons">
                        <span className="payment-icon">💰</span>
                    </div>
                </div>
            </div>
        </footer>
    )
}